import clsx from 'clsx'
import { useMemo } from 'react'
import { AccountAddress } from '../AccountAddressBook/AccountAddressBook'
import Button from '../Button/Button'
import LoadingButton from '../Button/LoadingButton'
import Modal, { useModal } from '../Modal/Modal'

export interface AccountAddressBookDeleteModalProps {
  /**
   * Recipient's contact info
   */
  contact: string | null
  /**
   * Recipient's current address
   */
  currentAddress: AccountAddress
  /**
   * Is deleting address
   */
  isDeletingAddress?: boolean
  /**
   * Callback on delete
   */
  onDelete: () => void
}

export default function AccountAddressBookDeleteModal({
  contact,
  currentAddress,
  isDeletingAddress = false,
  onDelete,
}: AccountAddressBookDeleteModalProps) {
  const hideDialog = useModal((state) => state.hideDialog)

  const addressParts = useMemo(
    () =>
      [
        currentAddress.address1 || '',
        currentAddress.address2 || '',
        currentAddress.city || '',
        currentAddress.state || '',
        currentAddress.zip || '',
      ].filter(Boolean),
    [currentAddress],
  )

  return (
    <Modal
      id="account-address-book-delete-modal"
      title="Delete address"
      className="[&]:p-12"
      dialogPanelClass="[&]:max-w-[21.44rem] [&]:md:max-w-[35.31rem] w-full [&_h2]:mb-4"
      content={
        <div>
          <div
            className={clsx(
              'relative rounded-8 border border-current border-neutral-400 text-[12px] px-10 py-6 max-w-max mx-auto mb-4',
            )}
          >
            {contact && <div>{contact}</div>}
            {addressParts.map((content: string) => (
              <div key={content}>{content}</div>
            ))}
          </div>
          <div className="text-center mb-6">
            <p>Are you sure you want to delete this address?</p>
          </div>
          <div className="flex flex-col md:flex-row gap-x-[24px] gap-y-[8px]">
            <LoadingButton
              className="w-full"
              loading={isDeletingAddress}
              onClick={onDelete}
            >
              Delete
            </LoadingButton>
            <Button
              className="w-full"
              disabled={isDeletingAddress}
              onClick={() => hideDialog('account-address-book-delete-modal')}
              variant="secondary"
            >
              Cancel
            </Button>
          </div>
        </div>
      }
    />
  )
}
